var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundPinkBlob(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 261,
    height: 80,
    viewBox: "0 0 261 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M56.468 9.41c-24.21-8.206-48.311-13.94-53.73.42-10.175 26.96 12.502 17.034-.192 41.168-15.63 29.71 44.687 34.064 72.397 21.767 42.735-18.964 53.235 2.387 91.575 4.48 37.296 2.034 30.725-12.346 57.659-1.044 17.23 7.23 34.645.658 35.566-8.216.92-8.874-9.573-16.15-7.421-28.035 2.309-12.76 17.218-23.847 1.38-32.689-15.838-8.843-45.767-10.43-66.296 4.365C166.878 26.422 151.44-4.784 119.992.641 89.025 5.983 76.03 16.04 56.468 9.41"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#BCDACC",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe1eb",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H335V100H0z",
    transform: "translate(-37 -10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundPinkBlob);
export default __webpack_public_path__ + "static/media/background_pink_blob.bf72560cdac9d139237f51b122db50e7.svg";
export { ForwardRef as ReactComponent };